import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  // 購入確認ページでのあと払い購入
  submit(e) {
    const formData = new FormData(e.target.form);
    // フォームデータをJSONに変換
    const data = {};
    const order_form = {};
    const serial_codes = [];

    formData.forEach((value, key) => {
      if (key === "order_form[serial_codes][]") {
        serial_codes.push(value);
      } else if (key.includes("questionnaire_answers")) {
        // Skip "questionnaire_answers"
      } else {
        const match = key.match(/^order_form\[(.+)\]$/);
        if (match) {
          order_form[match[1]] = value;
        } else {
          data[key] = value;
        }
      }
    });

    if (serial_codes.length !== 0) {
      order_form["serial_codes"] = serial_codes;
    }
    data.order_form = order_form;

    const questionnaire_answers = selectQuestionnaireAnswers();
    data.questionnaire_answers = questionnaire_answers;

    // POSTリクエストを送信
    fetch("/pre_purchase", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"), // RailsのCSRFトークン
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          // レスポンスが成功ステータスでない場合はエラーを表示する
          return response.json().then((errorData) => {
            displayErrorMessages(errorData.errors);
            setAttributesErrorMessage(errorData.attributes);
          });
        } else {
          return response.json().then((data) => {
            window.orderId = data.order_id;
            // 仮申込IDをMergeしたPaymentDataに更新して決済処理開始
            /* eslint-disable */
            Np.merge({
              services: [
                {
                  service_type: window.atoneServiceType,
                  payment: data.request_info,
                },
              ],
            });
            Np.start(window.atoneServiceType);
            /* eslint-enable */
          });
        }
      })
      .catch(() => {
        displayErrorMessages([
          "申込でエラーが発生しました。\r\n再度チケット枚数を設定しなおし、申込みを行ってください。",
        ]);
      });
  }

  // あと払い当選後のクレジット購入
  winnerSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target.form);
    // フォームデータをJSONに変換
    const data = {};
    const winner_purchase_form = {};

    formData.forEach((value, key) => {
      const match = key.match(/^winner_purchase_form\[(.+)\]$/);
      if (match) {
        winner_purchase_form[match[1]] = value;
      } else {
        data[key] = value;
      }
    });
    data.winner_purchase_form = winner_purchase_form;

    // POSTリクエストを送信
    fetch(`/winner_purchases/${data.winner_purchase_form.order_id}/pre_purchase`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"), // RailsのCSRFトークン
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          // レスポンスが成功ステータスでない場合はエラーを表示する
          return response.json().then((errorData) => {
            displayErrorMessages(errorData.errors);
            setAttributesErrorMessage(errorData.attributes);
          });
        } else {
          return response.json().then((data) => {
            // あと払いの前処理から返却されたPaymentDataに更新して決済処理開始
            // あと払いの前処理: WinnerPurchasesController#pre_purchase
            /* eslint-disable */
            Np.merge({
              services: [
                {
                  service_type: window.atoneServiceType,
                  payment: data.request_info,
                },
              ],
            });
            Np.start(window.atoneServiceType);
            /* eslint-enable */
          });
        }
      })
      .catch(() => {
        displayErrorMessages([
          "申込でエラーが発生しました。\r\n再度チケット枚数を設定しなおし、申込みを行ってください。",
        ]);
      });
  }
}

// エラーメッセージの表示を行う
// エラーが発生したことがわかるように、表示場所をページTOPに持ってくる
function displayErrorMessages(errors) {
  $("#paymentErrorMessage").remove();
  $(".ly-section").append(`<div class="message message--error" id="paymentErrorMessage"></div>`);
  errors.forEach((error) => {
    const formattedError = String(error)
      .split(/\r?\n/)
      .map((line) => $("<span>").text(line).html())
      .join("<br>");
    $("#paymentErrorMessage").append(
      `<p class='form-error-text'><span class='icon-error'>エラー</span>${formattedError}</p>`,
    );
  });
  $("#modalSbpsPurchase").find(".js-modal-close").trigger("click");
  // submitボタンのdisabled解除
  $("#submit-button").prop("disabled", false);
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
}

// 各入力値の箇所の個別エラーメッセージ表示
function setAttributesErrorMessage(attributes) {
  // 既存のエラー箇所をすべて非表示にする
  $(".is-error").removeClass("is-error");
  $(".order_form-error-text").hide();

  attributes.forEach((attribute) => {
    if (attribute === "serial_codes") {
      serialCodeErrorShow();
      return;
    } else if (attribute === "questionnaire_answers") {
      questionnaireAnswerErrorShow();
      return;
    } else {
      $(`.input-order_form_${attribute}`).addClass("is-error");
      $(`#${attribute}`).show();
    }
  });
}

function serialCodeErrorShow() {
  $('input[name="order_form[serial_codes][]"').each((index, element) => {
    if ($(element).val() === "") {
      $(element).addClass("is-error");
      $(element).parent().siblings(".order_form-error-text").show();
    }
  });
}

function questionnaireAnswerErrorShow() {
  $(".ticket-form-question__list").each((index, element) => {
    // 必須の場合だけ未回答Validationを行う
    if ($(element).data("question-required") === true) {
      // 質問形式で分岐
      const question_type = $(element).data("question-type");
      if (question_type === "text") {
        if ($(element).find("textarea").val() === "") {
          $(element).find("textarea").addClass("is-error");
          $(element).siblings(".order_form-error-text").show();
        }
      } else {
        if ($(element).find("input:checked").length === 0) {
          $(element).find("input").addClass("is-error");
          $(element).siblings(".order_form-error-text").show();
        }
      }
    }
  });
}

function selectQuestionnaireAnswers() {
  const questionnaire_answers = {};
  $("#order_form_questionnaire_area")
    .find('input[type="radio"]:checked, input[type="checkbox"]:checked, textarea')
    .each(function () {
      var elementType = $(this).prop("nodeName").toLowerCase(); // 要素の種類を取得
      var name = $(this).attr("name"); // name属性を取得
      var current_number = 0;
      var value = null;

      // アンケートのIDを取得
      var matches = name.match(/\[(\d+)\]/);
      if (matches) {
        current_number = matches[1]; // マッチした番号を取得
      }

      // ラジオボタンやチェックボックスの場合は、チェックされているもののみ
      if (elementType === "input" && ($(this).attr("type") === "radio" || $(this).attr("type") === "checkbox")) {
        if (!$(this).is(":checked")) {
          return; // チェックされていない場合はスキップ
        }
      }

      // テキストエリアの場合は、空でないもの
      if (elementType === "textarea") {
        value = $(this).val().trim(); // 値を取得し、前後の空白を削除
        if (value !== "") {
          questionnaire_answers[current_number] = value; // アンケートのIDをキーにして値を格納
        }
      } else {
        if (elementType === "input" && $(this).attr("type") === "checkbox") {
          if (!questionnaire_answers[current_number]) {
            questionnaire_answers[current_number] = [];
          }
          questionnaire_answers[current_number].push($(this).val()); // チェックボックスの値を配列に格納
        } else {
          questionnaire_answers[current_number] = $(this).val(); // ラジオボタンの値を格納
        }
      }
    });
  return questionnaire_answers;
}
